/*
 * @package  diakonie-akademie
 * @author David Hellmann [david@hellmann.io]
 *
 * formBasic
 */

const appHeaderBasic = {
  cfg: {
    name: 'appHeader Basic',
    selectors: {
      mobileTrigger: '.js-mobileTrigger',
      searchTrigger: '.js-searchTrigger',
      searchCloser: '.js-searchCloser',
      searchInput: '.js-searchInput',
    },
    classes: {
      open: 'is-open--mobileNav',
      locked: 'is-locked--body',
      openSearch: 'is-open--search',
    },
    el: {
      $mobileTrigger: undefined,
      $searchTrigger: undefined,
      $searchCloser: undefined,
      $searchInput: undefined,
    },
    els: {
      $modules: undefined,
    },
  },

  setElements() {
    this.cfg.el.$mobileTrigger = document.querySelector(
      this.cfg.selectors.mobileTrigger,
    );
    this.cfg.el.$searchTrigger = document.querySelector(
      this.cfg.selectors.searchTrigger,
    );
    this.cfg.el.$searchCloser = document.querySelector(
      this.cfg.selectors.searchCloser,
    );
    this.cfg.el.$searchInput = document.querySelector(
      this.cfg.selectors.searchInput,
    );
  },

  toggleBodyClass(open, locked) {
    if (document.body.classList.contains(open)) {
      document.body.classList.remove(open);
      if (locked) {
        document.body.classList.remove(locked);
      }
    } else {
      document.body.classList.add(open);
      if (locked) {
        document.body.classList.add(locked);
      }
    }
  },

  init() {
    console.debug(`Init: ${this.cfg.name}`);
    this.setElements();

    // Mobile Nav
    if (this.cfg.el.$mobileTrigger) {
      this.cfg.el.$mobileTrigger.addEventListener('click', () => {
        this.toggleBodyClass(this.cfg.classes.open, this.cfg.classes.locked);
      });
    }

    // Search
    if (
      this.cfg.el.$searchTrigger &&
      this.cfg.el.$searchCloser &&
      this.cfg.el.$searchInput
    ) {
      this.cfg.el.$searchTrigger.addEventListener('click', () => {
        this.toggleBodyClass(this.cfg.classes.openSearch);
        this.cfg.el.$searchInput.focus();
      });

      this.cfg.el.$searchCloser.addEventListener('click', () => {
        this.toggleBodyClass(this.cfg.classes.openSearch);
      });
    }
  },
};

export default appHeaderBasic;
